<div class="main-div">
  <div></div>

  <div class="main-header">
    Add a <br />
    participant
  </div>

  <div class="break"></div>

  <div class="main-text">
    Scan the participant's <br />QR number and then fill in the details
  </div>
  <div class="break"></div>
  <mat-card class="card">
    <mat-card-content>
      <div class="card-header">Scan participant QR number</div>
      <div style="position:relative;">
        <div class="red-overlay"> 
        </div>
      <zxing-scanner
        #scanner
        class="scanner"
        [autofocusEnabled]="false"
        (scanSuccess)="onCodeResult($event)"
        (camerasFound)="onCamerasFound($event)"
        [formats]="formatsEnabled"
        [tryHarder]="tryHarder"
      ></zxing-scanner></div>
      <mat-form-field appearance="fill" class="cameradropdown">
        <select
          matNativeControl
          matInput
          (change)="onDeviceSelectChange($event.target.value)"
        >
          <option value="null">Click me to select a camera</option>
          <option
            *ngFor="let device of availableDevices"
            [value]="device.deviceId"
            [selected]="selectedCamera === device.deviceId"
          >
            {{ device.label }}
          </option>
        </select>
      </mat-form-field>

      <div class="spacer"></div>
      <div class="or-text">OR</div>
      <div class="spacer"></div>
      <div class="break"></div>
      <div class="spacer"></div>
      <div class="main-div">
        <mat-card class="card2" (click)="gotokeyboard()">
          <div class="icon-container">
            <mat-icon
              aria-hidden="false"
              aria-label="Type the QR number"
              class="mat-icon-style"
              >keyboard</mat-icon
            >
          </div>
          <div class="break"></div>
          <div class="break"></div>
          Keyboard
        </mat-card>
      </div>
    </mat-card-content></mat-card
  >
</div>

<div class="break"></div>
<div class="spacer"></div>

<app-mat-spinner-overlay overlay="true" *ngIf="loading">
</app-mat-spinner-overlay>
